import { render, staticRenderFns } from "./AccessPointControllerForm.vue?vue&type=template&id=60181eac&scoped=true"
import script from "./AccessPointControllerForm.vue?vue&type=script&lang=js"
export * from "./AccessPointControllerForm.vue?vue&type=script&lang=js"
import style0 from "./AccessPointControllerForm.vue?vue&type=style&index=0&id=60181eac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60181eac",
  null
  
)

export default component.exports